export const institutionsPercentage = [
  {
    "label": "Enriched",
    "count": "511"
  },
  {
    "label": "Not-enriched",
    "count": "955"
  }
]